import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highcharts3d from 'highcharts/highcharts-3d';
import { highchartsGlobalOptions } from './chartOptions';
if (typeof window !== 'undefined') {
  Highcharts.setOptions(highchartsGlobalOptions);
  highcharts3d(Highcharts);
}
export var Chart3d = function Chart3d(props) {
  return React.createElement(HighchartsReact, {
    highcharts: Highcharts,
    options: props.options
  });
};